import { addDoc, collection } from "@firebase/firestore"
import { showErrorSnackbar, showSuccessSnackbar } from "../../../shared/snackbar/snackbar-slice";
import { addCategories } from "../item-categories-list/item-categories-list-slice";
import { hideLoading, showLoading } from "./item-categories-add-slice";

export const addItemCategoriesService = async (dispatch, db, coll, formData) => {
    dispatch(showLoading());
    try {
        const docRef = await addDoc(collection(db, coll), formData);
        dispatch(addCategories({
            id: docRef.id,
            ...formData
        }));
        dispatch(showSuccessSnackbar('Added successfully!'));
    } catch(e) {
        dispatch(showErrorSnackbar('Add failed! Please try again.'))
        console.error("ItemCategoriesAdd addItemCategoriesService error: ", e);
    }
    dispatch(hideLoading());
};